export default __webpack_public_path__ + "static/media/seguridad.942c3958.png";